// Professional Summary on the landing page
export const professionalSummary = {
  title: "Full Stack Developer",
  textArr: [
    `I’m a software developer with a focus in ethical client-minded design, believing that tech should minimize the stressors in our lives, not magnify them. When it comes to programming, I’m passionate about efficiency, readability, documentation, and testing. I thrive under pressure and tight-deadlines while maintaining my composure, reliability, and dependability. By bringing a forward thinking approach to designing solutions, I keep scalability and optimization at the forefront of my problem solving.`,
  ],
  img: `/img/profile.jpg`,
};

// About Me section on the landing page
export const aboutMe = {
  title: "About Me",
  textArr: [
    `I’m a first generation immigrant of Polish descent. Though I emigrated from Poland when I was young, I hold my culture close to my heart. I am deeply saddened whenever there aren't any good pickles, kielbasa, or loaves of bread nearby. I'm sure by the adjacent image you can tell what my favorite food is (it's pierogi)`,
    `During my spare time I like to go hiking with my dog, Beans, watch arthouse films, collect records, and cook extravagant meals. I have a pretty heavy-duty DIY attitude so occasionally you might find me tinkering with a Raspberry Pi, woodworking, gardening, embroidering, or even fermenting my own foods!`,
  ],
  img: `/img/pierogi2.png`,
};
